import { Client } from '@/common/services/Client';
import Paginated from '@/common/types/paginated';

import { PolicySortField, SortOrder } from '../types/SortTypes';
import { PolicyStatus } from './PolicyStatus';

export interface PolicySummary {
  uuid: string;
  epicPolicyUuid: string | null;
  accountName: string;
  fileName: string;
  policyNumber: string;
  insurer: string;
  expiryDate: string;
  technicalSupport: string;
  status: PolicyStatus;
  attachmentId: number;
  createdAt: string;
  validatedAt: string | null;
  isLocked: boolean;
  assignedUserId: string | null;
  assignedUserName: string | null;
}

export type PaginationParams = {
  pageIndex: number;
  pageSize: number;
  sortBy: PolicySortField;
  sortOrder: SortOrder;
};

export type PolicyFilters = {
  accountName: string;
  fileName: string;
  policyNumber: string;
  insurer: string;
  technicalSupport: string;
  status: string;
};

export interface PaginatedPoliciesResponse {
  policies: PolicySummary[];
  totalPages: number;
  totalPolicies: number;
}

const defaultParams: PaginationParams = {
  pageIndex: 0,
  pageSize: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
};

export async function fetchPaginatedPoliciesSummary(
  params = defaultParams,
  filters?: Partial<PolicyFilters>,
  signal?: AbortSignal,
): Promise<Paginated<PolicySummary>> {
  const queryParams: PaginationParams & Partial<PolicyFilters> = {
    pageIndex: params.pageIndex,
    pageSize: params.pageSize,
    sortBy: params.sortBy,
    sortOrder: params.sortOrder,
    ...filters,
  };

  const response = await Client.get<PaginatedPoliciesResponse>({
    endpoint: `/policies/summary/paginated`,
    params: queryParams,
    signal,
  });

  return {
    items: response.data.policies,
    totalItems: response.data.totalPolicies,
    totalPages: response.data.totalPages,
  };
}
